import { createSlice } from "@reduxjs/toolkit";
import { getSubNavigations } from "./subNavigationThunk";

const initialState = {
  loading: false,
  subNavigationList: [],
  pagination: {},
  error: null,
};

const subNavigationSlice = createSlice({
  name: "subNavigation",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getSubNavigations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSubNavigations.fulfilled, (state, action) => {
        state.loading = false;
        state.subNavigationList = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(getSubNavigations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default subNavigationSlice.reducer;
